import React from "react"

import { BottomNavigation } from "@mui/material";
import baseline from '../images/vaucluse-naturellement-Provence.png'
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

export default function FootBar() {
//    <AppBar position="static" sx={{ top: 'auto', bottom: 0 ,maxHeight: '10vh' }}>
//    <Paper elevation={3} sx={{ top: 'auto', bottom: 0 ,maxHeight: '10vh',opacity:"50%",position:"static",color:"secondary" }}>
//sx={{ height: "10vh", width: "auto" }}
  return (
    <Paper elevation={0} >
      <BottomNavigation>
        <Box
          component="img"
          alt="Baseline"
          src={baseline}
        />
      </BottomNavigation>
    </Paper>
  )
}